import Index from '../views/index/index.vue'
import Login from '../views/login/login.vue'
import WX_Delivery from '../views/delivery/wx-delivery-list'
import ZBZ_Delivery from '../views/delivery/zbz-delivery-list'
import JX_Delivery from '../views/delivery/jx-delivery-list'
import LYD_Delivery from '../views/delivery/ldy-delivery-list'
import TOP_Delivery from '../views/delivery/top-delivery-list'
import GJ_Delivery from '../views/delivery/gj-delivery-list'

export default [{
  path: '/index',
  name: 'Index',
  component: Index,
  children: [{
      path: '/index/wx-delivery',
      component: WX_Delivery,
    }, {
      path: '/index/zbz-delivery',
      component: ZBZ_Delivery,
    }, {
      path: '/index/jx-delivery',
      component: JX_Delivery,
    },
    {
      path: '/index/ldy-delivery',
      component: LYD_Delivery,
    },
    {
      path: '/index/top-delivery',
      component: TOP_Delivery,
    },
    {
      path: '/index/gj-delivery',
      component: GJ_Delivery,
    },
  ]
}, {
  path: '/login',
  name: 'Login',
  component: Login,
}, {
  path: '/',
  name: 'Index',
  component: Index,
}]



// WEBPACK FOOTER //
// ./src/router/config.js